export const GET_ORIGINE_CHIAMATE_DATA_AND_LOADING =
  "GET_ORIGINE_CHIAMATE_DATA_AND_LOADING";
export const EXPORT_AREE_LOADING = "EXPORT_AREE_LOADING";
export const IMPORT_AREE_LOADING = "IMPORT_AREE_LOADING";
export const CREATE_UPDATE_DELETE_AREE = "CREATE_UPDATE_DELETE_AREE";
export const GET_CURRENT_AREE = "GET_CURRENT_AREE";
export const GET_CURRENT_ITEM_LIST = "GET_CURRENT_ITEM_LIST";
